// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_fa9893', '__Montserrat_Fallback_fa9893'","fontStyle":"normal"},"className":"__className_fa9893"};